import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import axios from "axios";
import configuration from "@/utils/configuration";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/components/navigation/layoutWithNavbar.vue"),
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/homeView.vue"),
      },
      {
        path: "notification",
        name: "notification",
        
        component: () => import("@/views/setting/notificationView.vue"),
      },

      {
        path: "course",
        name: "course",
        component: () => import("@/views/course/mainCourseView.vue"),
      },
      {
        path: "/course/:id",
        name: "CourseDetail",
        component: () => import("@/views/course/courseDetail.vue"),
      },
      {
        path: "/course/enrollments/:id",
        name: "course-enrollments",
        meta: { requireAuth: true },
        component: () => import("@/views/course/shortCourseEnrollView.vue"),
      },
      {
        path: "/course/package/:id",
        name: "package",
        meta: { requireAuth: true },
        component: () => import("@/views/course/packageSelectView.vue"),
      },
      {
        path: "order",
        name: "order",
        component: () => import("@/views/course/courseOrderView.vue"),
        meta: { requireAuth: true },
      },
      {
        path: "cart",
        name: "cart",
        component: () => import("@/views/cart/cartView.vue"),
        meta: { requireAuth: true },
      },
      {
        path: "purchase-history/:tab?/:id?",
        name: "purchase",
        component: () => import("@/views/cart/purchaseHistory.vue"),
        meta: { requireAuth: true },
      },
      {
        path: "/payment/success/:id",
        name: "payment-success",
        component: () => import("@/views/purchase/purchaseCompleted.vue"),
        meta: { requireAuth: true },
      },
      {
        path: "coach/management/:tab?/:courseId?",
        name: "coach-management",
        component: () => import("@/views/coach/coachManageView.vue"),
        meta: {allowSharedToken:true, requireAuth: true, requireRole: ["COACH"] },
      },
      {
        path: "coach/class-manage/:id",
        name: "class-manage",
        meta: { requireAuth: true, requireRole: ["COACH"] },
        component: () => import("@/views/coach/classManageView.vue"),
        
      },
      {
        path: "purchase-orderHistory",
        name: "purchase-orderHistory",
        component: () => import("@/views/cart/purchaseHistory.vue"),
        meta: { requireAuth: true}
      },
      {
        path: "profile/edit",
        name: "edit-profile",
        component: () => import("@/views/profile/editProfileView.vue"),
         meta: { requireAuth: true}
      },
      {
        path: "profile",
        name: "profile",
        component: () => import("@/views/profile/studentProfile.vue"),
        meta: { requireAuth: true, requireRole: ["STUDENT"] },
      },
      {
        path: "parent-profile",
        name: "parent-profile",
        component: () => import("@/views/profile/parentProfile.vue"),
        meta: { requireAuth: true, requireRole: ["PARENT"] },
      },
      {
        path: "certificate/:id?",
        name: "certificate",
        component: () => import("@/views/profile/certificateView.vue"),
        meta: { requireAuth: true, requireRole: ["STUDENT", "PARENT"] },
      },
      {
        path: "term-of-service",
        name: "term-of-service",
        component: () => import("@/views/setting/termOfService.vue"),
      },
      {
        path: "learner-schedules/:tab?/:id?",
        name: "learner-schedules",
        meta: {allowSharedToken:true, requireAuth: true, requireRole: ["STUDENT", "PARENT","GUEST"] },
        component: () => import("@/views/learner/learnerClassInfo.vue"),
      },
      {
        path: "course-attendance/:id",
        name: "course-attendance",
        component: () => import("@/views/learner/classInfo.vue"),
        meta: { requireAuth: true, requireRole: ["STUDENT", "PARENT"] },
      },
      {
        path: "course-attendance/:id",
        name: "child-attendance",
        component: () => import("@/views/learner/parentClassDetail.vue"),
        meta: { requireAuth: true, requireRole: ["STUDENT", "PARENT"] },
      },
      {
        path: "consent",
        name: "consent",
        component: () => import("@/views/consentView.vue"),
        meta: { requireAuth: true, requireRole: ["STUDENT", "PARENT"] },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/auth/loginView.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("@/views/auth/registerView.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("@/views/setting/forgotPassword.vue"),
  },
  {
    path: "/forgot-password/verify",
    name: "sms-verify",
    component: () => import("@/views/setting/sendingOTPView.vue"),
  },
  {
    path: "/new-password",
    name: "new-password",
    component: () => import("@/views/setting/newPasswordView.vue"),
  },
  {
    path: "/admin",
    component: () => import("@/components/navigation/adminLayout.vue"),
    meta: { requireAuth: true, requireRole: ["ADMIN"] },
    children: [
      {
        path: "student-list/:status",
        name: "student-list",
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
        component: () => import("@/views/admin/adminStudentList.vue"),
      },
      {
        path: "manage-consent",
        name: "manage-consent",
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
        component: () => import("@/views/admin/adminPdpaManageView.vue"),
      },
      {
        path: "course-statistic",
        name: "course-statistic",
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
        component: () => import("@/views/admin/dashboardCourseList.vue"),
      },
      {
        path: "dashboard",
        name: "dashboard",
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
        component: () => import("@/views/admin/dashboardView.vue"),
      },
      {
        path: "manage-course",
        name: "manage-course",
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
        component: () => import("@/views/admin/courseListView.vue"),
      },
      {
        path: "teaching-schedule",
        name: "teaching-schedule",
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
        component: () => import("@/views/admin/adminTimeTable.vue"),
      },
      {
        path: "manage-course/edit/:id/CT_01",
        name: "edit-general-course",
        component: () => import("@/views/admin/manageGeneralCourse.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "manage-course/edit/:id/CT_02",
        name: "edit-short-course",
        component: () => import("@/views/admin/manageShortCourse.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "create-course",
        name: "create-course",
        component: () => import("@/views/admin/createCourseView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "create-sphere",
        name: "create-sphere",
        component: () => import("@/views/admin/createCategoryView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "manage-sphere",
        name: "manage-sphere",
        component: () => import("@/views/admin/categoryListView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      }, 

      {
        path: "manage-sphere/edit/:id",
        name: "edit-sphere",
        component: () => import("@/views/admin/manageCategoryView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "manage-user",
        name: "manage-user",
        component: () => import("@/views/manageUser/userListView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "manage-user/create",
        name: "create-user",
        component: () => import("@/views/manageUser/addNewUserView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "manage-user/edit/:id",
        name: "edit-user",
        component: () => import("@/views/manageUser/editUserView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "financial",
        name: "financial",
        component: () => import("@/views/finance/financeView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "reservation",
        name: "reservation",
        component: () => import("@/views/course/manageCourseReserve.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "financial/detail/:id",
        name: "financial-detail",
        component: () => import("@/views/finance/financeDetail.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "enroll-student",
        name: "enroll-student",
        component: () => import("@/views/admin/enrollStudentView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "manage-schedule",
        name: "manage-schedule",
        component: () => import("@/views/admin/adminScheduleView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "manage-leaves",
        name: "manage-leaves",
        component: () => import("@/views/admin/adminLeaveView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "manage-leave/detail/:id",
        name: "leave-detail",
        component: () => import("@/views/admin/adminLeaveDetail.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "events",
        name: "events",
        component: () => import("@/views/events/eventsSetting.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "manage-leave/new-request",
        name: "leave-requestForm",
        component: () => import("@/components/form/addNewLeaveForm.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "attendance-view",
        name: "attendance-view",
        component: () => import("@/views/admin/adminAttendanceView.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      },
      {
        path: "attendance-detail",
        name: "attendance-detail",
        component: () => import("@/views/admin/adminAttendanceDetail.vue"),
        meta: { requireAuth: true, requireRole: ["ADMIN"] },
      }
    ],
  },
];



const router = new VueRouter({

  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  store.commit('settingModules/SET_ROUTE_LOADING', true);
  try {
    if (to.query.token && to.meta.allowSharedToken) {
      await store.dispatch("authModules/loginSharedToken", to.query.token);
      await store.dispatch("profileModules/getUserProfile");
      const query = { ...to.query };
      delete query.token;
      next({ ...to, query });
      return;
    }
    if (to.meta.requireAuth) {
      const { data } = await axios.get(`${configuration.authUrl}/verify-token`, { withCredentials: true });
      if (data.statusCode !== 200) {
        next({ name: "login" });
        return;
      }
      if (to.meta.requireRole) {
        const hasRole = data.data.role.some(role => to.meta.requireRole.includes(role));
        hasRole ? next() : next({ name: "home" });
        return;
      }
      next();
    } else {
      next();
    }
  } catch (err) {
    next({ name: "login" });
  } finally {
    store.commit('settingModules/SET_ROUTE_LOADING', false);
  }
});

router.afterEach(() => {
  store.commit("buyCourseModules/RESET_COURSE_SELECTION");
  store.commit("buyCourseModules/RESET_PROGRESS");
});
router.afterEach((to, from) => {
  store.commit("settingModules/SET_PREVIOUS_ROUTE", from.name);
});

export default router;
